import { Footprints, Stethoscope, Smartphone } from "lucide-react";
import { Reveal } from "../landing/shared";
import { SITE } from "@/config";

const CARDS = [
  {
    num: "01",
    icon: Footprints,
    title: "Premium Toilet Footstool",
    copy: "A foldable toilet footstool designed to support a more natural toilet posture.",
  },
  {
    num: "02",
    icon: Stethoscope,
    title: "Free Doctor Counselling",
    copy: "Personalised constipation counselling by Dr. Burhan Shaikh.",
    free: true,
  },
  {
    num: "03",
    icon: Smartphone,
    title: "Free Better Bowel Routine Guide",
    copy: "A simple digital guide covering toilet posture, bowel habits, hydration, fibre and practical constipation-care tips.",
    free: true,
  },
];

const Inclusions = () => (
  <section data-testid="whats-inside-section" className="bg-ivory py-14 sm:py-20">
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
      <div className="rounded-[2rem] border border-gold/30 bg-white/50 p-6 shadow-[0_25px_60px_-35px_rgba(27,42,74,0.35)] sm:p-10 lg:p-12">
        <Reveal className="text-center">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold">The complete kit</p>
        </Reveal>
        <Reveal delay={0.05} className="text-center">
          <h2 className="mt-3 font-serif text-3xl leading-[1.12] tracking-tight text-navy sm:text-4xl lg:text-5xl" data-testid="whats-inside-headline">
            What&rsquo;s Inside Your Kit?
          </h2>
        </Reveal>

        <div className="mt-10 grid gap-4 sm:grid-cols-3 sm:gap-6">
          {CARDS.map(({ num, icon: Icon, title, copy, free }, i) => (
            <Reveal key={num} delay={0.08 + i * 0.1} className="h-full">
              <div
                data-testid={`whats-inside-card-${num}`}
                className={`relative flex h-full flex-col rounded-3xl border bg-white p-6 transition-[transform,box-shadow] duration-400 hover:-translate-y-1 sm:p-7 ${
                  free
                    ? "border-gold/50 shadow-[0_18px_40px_-20px_rgba(185,155,92,0.45)]"
                    : "border-navy/10 shadow-[0_18px_40px_-24px_rgba(27,42,74,0.35)]"
                }`}
              >
                {free && (
                  <span className="absolute -top-3 left-6 rounded-full bg-gold px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.2em] text-navy">
                    Free
                  </span>
                )}
                <div className="flex items-center justify-between">
                  <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-ivory text-navy">
                    <Icon className="h-5 w-5" />
                  </span>
                  <span className="font-serif text-3xl italic text-gold/70">{num}</span>
                </div>
                <h3 className="mt-5 font-serif text-xl font-semibold uppercase leading-snug tracking-wide text-navy">
                  {title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-charcoal/75">{copy}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-10 text-center">
          <div className="hairline mx-auto max-w-md" />
          <p className="mt-6 text-base text-charcoal/80 sm:text-lg" data-testid="whats-inside-price-line">
            Everything you need to build a better bathroom routine —{" "}
            <span className="font-serif text-3xl font-semibold text-gold sm:text-4xl" data-testid="whats-inside-price">
              {SITE.price}
            </span>
          </p>
          <a
            data-testid="whats-inside-buy-now-button"
            href={SITE.razorpayUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 inline-flex w-full items-center justify-center rounded-full bg-navy px-9 py-4 text-sm font-extrabold uppercase tracking-[0.12em] text-ivory shadow-[0_16px_38px_-14px_rgba(27,42,74,0.6)] transition-[transform,box-shadow,background-color] duration-300 hover:-translate-y-0.5 hover:bg-navy-deep active:translate-y-0 sm:w-auto"
          >
            Buy Now — {SITE.price}
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Inclusions;
